module.exports = __webpack_public_path__ + "img/ico-scrap-s.f4edecfa.svg";